import React, { useContext } from 'react';
import { StoreContext } from '../../utils/store';
import styles from './Overlay.module.css';

const Overlay = () => {
  const context = useContext(StoreContext);
  const [modalStatus, setModalStatus] = context.modalStatus;
  return (
      <div
        className={modalStatus.overlayActive ? styles.overlayActive : styles.overlayHidden}
        onClick={() => {
          setModalStatus(status => ({
            ...status,
            overlayActive: false,
            modalActive: false,
          }));
        }}
      ></div>
  );
};

export default Overlay;
